import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import LocalStorageManager from './LocalStorageManager';

@Injectable({
  providedIn: 'root',
})
export class EventBusService {
  private step: number = 1;

  private stepSubject$ = new BehaviorSubject<number>(1);
  stepChanged$ = this.stepSubject$.asObservable();

  constructor() {
    this.step = LocalStorageManager.get('step') || 1;

    this.stepSubject$.next(this.step);
  }
  nextStep(step?: number) {
    this.step = step || this.step + 1;
    LocalStorageManager.set('step', this.step);
    this.stepSubject$.next(this.step);
  }
  previousStep(step?: number) {
    this.step = step || this.step - 1 || 1;

    LocalStorageManager.set('step', this.step);
    this.stepSubject$.next(this.step);
  }

  clearStep() {
    LocalStorageManager.clearWithKey('step');
    this.step = 1;
    this.stepSubject$.next(this.step);
  }
  setStep(step: number) {
    this.step = step;
    LocalStorageManager.set('step', this.step);
    this.stepSubject$.next(this.step);
  }
  getStep() {
    return this.step;
  }
}
